const EN_TRANSLATE = {
    Username: "Username",
    Password: "Password",
    Name: "Name",
};

export default EN_TRANSLATE;